import ctmeta from "./default.json";

export function getContentTypeData() {
  return ctmeta;
}
